import { stringify } from 'query-string';
import { DataProviderPayload } from './types';

export const getQuery = (payload: DataProviderPayload): string => {
  const query: Partial<Record<'sort' | 'range' | 'filter' | 'defer_count' | 'count_only', string>> = {};

  if (payload?.sort) {
    const { field, order } = payload.sort;
    query.sort = JSON.stringify([field, order]);
  }

  if (payload?.pagination) {
    const { page, perPage } = payload.pagination;
    const start = (page - 1) * perPage;
    const end = page * perPage - 1;
    query.range = JSON.stringify([start, end]);
  }

  if (payload?.filter) query.filter = JSON.stringify(payload.filter);
  if (payload?.meta?.deferCount) query.defer_count = '1';
  if (payload?.meta?.countOnly) query.count_only = '1';

  return stringify(query);
};
